var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
      attrs: { "data-active-cat": _vm.selectedCatIds }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized"
            }
          ]
        },
        [
          _c(
            "div",
            {
              staticClass: "mobile-close",
              on: {
                click: function($event) {
                  return _vm.closeNavigation()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          ),
          _vm._v(" "),
          _c(
            "lazy-load",
            { attrs: { component: "phywe-avatar-mobile" } },
            [_c("phywe-avatar-mobile", { attrs: { lang: _vm.Sprache } })],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" }
            },
            [
              _vm.dataContainer1.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer1.parent &&
                              _vm.dataContainer1.parent.parent) ||
                              null,
                            true
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "nav-direction d-flex align-items-center mHeader"
                        },
                        [
                          _vm.selectedCat
                            ? [
                                _c("i", {
                                  staticClass: "fa fa-long-arrow-left",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-fill text-center" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.selectedCat.details[0].name
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer1.categories, function(category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.getCategoryUrl(category.url) } },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function($event) {
                              return _vm.slideTo(category)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-lg fa-caret-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer1.categories[0]
                ? _vm._l(
                    _vm.dataContainer1.categories[0].siblingCount -
                      _vm.dataContainer1.categories.length,
                    function(number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" }
                        })
                      ])
                    }
                  )
                : _vm.dataContainer1.parent
                ? _vm._l(_vm.dataContainer1.parent.childCount, function(
                    number
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.breadcrumbs.length == 0
                ? [
                    _c("li", { staticClass: "ddown" }, [
                      _c("a", { attrs: { href: _vm.urlService } }, [
                        _c("img", {
                          attrs: {
                            src:
                              "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/service.svg",
                            width: "25"
                          }
                        }),
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$translate("Phywe::Template.serviceIconText")
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.pid === "49091"
                      ? [
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(1) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu1"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(2) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu2"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(3) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu3"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ])
                        ]
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0",
              attrs: { id: "menu-2" }
            },
            [
              _vm.dataContainer2.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer2.parent &&
                              _vm.dataContainer2.parent.parent) ||
                              null,
                            true
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "nav-direction d-flex align-items-center mHeader"
                        },
                        [
                          _vm.selectedCat
                            ? [
                                _c("i", {
                                  staticClass: "fa fa-long-arrow-left",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-fill text-center" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.selectedCat.details[0].name
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function(category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.getCategoryUrl(category.url) } },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function($event) {
                              return _vm.slideTo(category)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-lg fa-caret-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer2.categories[0]
                ? _vm._l(
                    _vm.dataContainer2.categories[0].siblingCount -
                      _vm.dataContainer2.categories.length,
                    function(number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" }
                        })
                      ])
                    }
                  )
                : _vm.dataContainer2.parent
                ? _vm._l(_vm.dataContainer2.parent.childCount, function(
                    number
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.breadcrumbs.length == 0
                ? [
                    _c("li", { staticClass: "ddown" }, [
                      _c("a", { attrs: { href: _vm.urlService } }, [
                        _c("img", {
                          attrs: {
                            src:
                              "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/service.svg",
                            width: "25"
                          }
                        }),
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$translate("Phywe::Template.serviceIconText")
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.pid === "49091"
                      ? [
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(1) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu1"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(2) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu2"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(3) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu3"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ])
                        ]
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                on: {
                  click: function($event) {
                    return _vm.closeNavigation()
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("loading-animation")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }